export enum CheckDigitAlgorithm {
None,
Piraeus1,
}
